/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccountSummary } from '../models';
// @ts-ignore
import type { EquityOrderResult } from '../models';
// @ts-ignore
import type { EquityPosition } from '../models';
// @ts-ignore
import type { Instrument } from '../models';
// @ts-ignore
import type { LimitOrderRequest } from '../models';
// @ts-ignore
import type { MarketOrderRequest } from '../models';
/**
 * Trading212PublicAPIApi - axios parameter creator
 * @export
 */
export const Trading212PublicAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel a pending or queued equity order by its ID.
         * @summary Cancel order
         * @param {number} id 
         * @param {CancelOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (id: number, accountId?: CancelOrderAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelOrder', 'id', id)
            const localVarPath = `/api/trading212-public/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve account summary including total value, cash breakdown, and investment P&L from the Trading212 public API
         * @summary Get account summary
         * @param {GetAccountSummaryAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSummary: async (accountId?: GetAccountSummaryAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-public/account/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the Trading 212 instrument universe by symbol or name and return the full Trading 212 tickers. Powers the search-as-you-type box on the ISA page. Matches case-insensitively on short name, ticker prefix, or name substring, ranked best-match first. Never fails the request: an upstream fetch error yields an empty list.
         * @summary Search instruments
         * @param {string} query Free-text query: symbol or name fragment. Blank yields an empty result list.
         * @param {number} [limit] Maximum number of results to return. Clamped to [1, 50]. Defaults to 20.
         * @param {GetInstrumentSearchAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentSearch: async (query: string, limit?: number, accountId?: GetInstrumentSearchAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('getInstrumentSearch', 'query', query)
            const localVarPath = `/api/trading212-public/instruments/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single equity order by its ID from the Trading212 public API
         * @summary Get order by ID
         * @param {number} id 
         * @param {GetOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (id: number, accountId?: GetOrderAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrder', 'id', id)
            const localVarPath = `/api/trading212-public/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all equity orders from the Trading212 public API
         * @summary Get all orders
         * @param {GetOrdersAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (accountId?: GetOrdersAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-public/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single open equity position for the given ticker from the Trading212 public API
         * @summary Get position by ticker
         * @param {string} ticker 
         * @param {GetPositionAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: async (ticker: string, accountId?: GetPositionAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getPosition', 'ticker', ticker)
            const localVarPath = `/api/trading212-public/positions/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all open equity positions from the Trading212 public API
         * @summary Get all open positions
         * @param {GetPositionsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions: async (accountId?: GetPositionsAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-public/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place a limit order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
         * @summary Place limit order
         * @param {LimitOrderRequest} limitOrderRequest 
         * @param {PlaceLimitOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeLimitOrder: async (limitOrderRequest: LimitOrderRequest, accountId?: PlaceLimitOrderAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limitOrderRequest' is not null or undefined
            assertParamExists('placeLimitOrder', 'limitOrderRequest', limitOrderRequest)
            const localVarPath = `/api/trading212-public/orders/limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(limitOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place a market order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
         * @summary Place market order
         * @param {MarketOrderRequest} marketOrderRequest 
         * @param {PlaceMarketOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeMarketOrder: async (marketOrderRequest: MarketOrderRequest, accountId?: PlaceMarketOrderAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketOrderRequest' is not null or undefined
            assertParamExists('placeMarketOrder', 'marketOrderRequest', marketOrderRequest)
            const localVarPath = `/api/trading212-public/orders/market`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Trading212PublicAPIApi - functional programming interface
 * @export
 */
export const Trading212PublicAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Trading212PublicAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel a pending or queued equity order by its ID.
         * @summary Cancel order
         * @param {number} id 
         * @param {CancelOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(id: number, accountId?: CancelOrderAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(id, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve account summary including total value, cash breakdown, and investment P&L from the Trading212 public API
         * @summary Get account summary
         * @param {GetAccountSummaryAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountSummary(accountId?: GetAccountSummaryAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountSummary(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.getAccountSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search the Trading 212 instrument universe by symbol or name and return the full Trading 212 tickers. Powers the search-as-you-type box on the ISA page. Matches case-insensitively on short name, ticker prefix, or name substring, ranked best-match first. Never fails the request: an upstream fetch error yields an empty list.
         * @summary Search instruments
         * @param {string} query Free-text query: symbol or name fragment. Blank yields an empty result list.
         * @param {number} [limit] Maximum number of results to return. Clamped to [1, 50]. Defaults to 20.
         * @param {GetInstrumentSearchAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstrumentSearch(query: string, limit?: number, accountId?: GetInstrumentSearchAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Instrument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstrumentSearch(query, limit, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.getInstrumentSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single equity order by its ID from the Trading212 public API
         * @summary Get order by ID
         * @param {number} id 
         * @param {GetOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(id: number, accountId?: GetOrderAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquityOrderResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(id, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.getOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all equity orders from the Trading212 public API
         * @summary Get all orders
         * @param {GetOrdersAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(accountId?: GetOrdersAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquityOrderResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single open equity position for the given ticker from the Trading212 public API
         * @summary Get position by ticker
         * @param {string} ticker 
         * @param {GetPositionAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosition(ticker: string, accountId?: GetPositionAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquityPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPosition(ticker, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.getPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all open equity positions from the Trading212 public API
         * @summary Get all open positions
         * @param {GetPositionsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions(accountId?: GetPositionsAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquityPosition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.getPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Place a limit order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
         * @summary Place limit order
         * @param {LimitOrderRequest} limitOrderRequest 
         * @param {PlaceLimitOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeLimitOrder(limitOrderRequest: LimitOrderRequest, accountId?: PlaceLimitOrderAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquityOrderResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeLimitOrder(limitOrderRequest, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.placeLimitOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Place a market order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
         * @summary Place market order
         * @param {MarketOrderRequest} marketOrderRequest 
         * @param {PlaceMarketOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeMarketOrder(marketOrderRequest: MarketOrderRequest, accountId?: PlaceMarketOrderAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquityOrderResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeMarketOrder(marketOrderRequest, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212PublicAPIApi.placeMarketOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Trading212PublicAPIApi - factory interface
 * @export
 */
export const Trading212PublicAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Trading212PublicAPIApiFp(configuration)
    return {
        /**
         * Cancel a pending or queued equity order by its ID.
         * @summary Cancel order
         * @param {number} id 
         * @param {CancelOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(id: number, accountId?: CancelOrderAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelOrder(id, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve account summary including total value, cash breakdown, and investment P&L from the Trading212 public API
         * @summary Get account summary
         * @param {GetAccountSummaryAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSummary(accountId?: GetAccountSummaryAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<AccountSummary> {
            return localVarFp.getAccountSummary(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search the Trading 212 instrument universe by symbol or name and return the full Trading 212 tickers. Powers the search-as-you-type box on the ISA page. Matches case-insensitively on short name, ticker prefix, or name substring, ranked best-match first. Never fails the request: an upstream fetch error yields an empty list.
         * @summary Search instruments
         * @param {string} query Free-text query: symbol or name fragment. Blank yields an empty result list.
         * @param {number} [limit] Maximum number of results to return. Clamped to [1, 50]. Defaults to 20.
         * @param {GetInstrumentSearchAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentSearch(query: string, limit?: number, accountId?: GetInstrumentSearchAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<Instrument>> {
            return localVarFp.getInstrumentSearch(query, limit, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single equity order by its ID from the Trading212 public API
         * @summary Get order by ID
         * @param {number} id 
         * @param {GetOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(id: number, accountId?: GetOrderAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<EquityOrderResult> {
            return localVarFp.getOrder(id, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all equity orders from the Trading212 public API
         * @summary Get all orders
         * @param {GetOrdersAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(accountId?: GetOrdersAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<EquityOrderResult>> {
            return localVarFp.getOrders(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single open equity position for the given ticker from the Trading212 public API
         * @summary Get position by ticker
         * @param {string} ticker 
         * @param {GetPositionAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(ticker: string, accountId?: GetPositionAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<EquityPosition> {
            return localVarFp.getPosition(ticker, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all open equity positions from the Trading212 public API
         * @summary Get all open positions
         * @param {GetPositionsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions(accountId?: GetPositionsAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<EquityPosition>> {
            return localVarFp.getPositions(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Place a limit order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
         * @summary Place limit order
         * @param {LimitOrderRequest} limitOrderRequest 
         * @param {PlaceLimitOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeLimitOrder(limitOrderRequest: LimitOrderRequest, accountId?: PlaceLimitOrderAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<EquityOrderResult> {
            return localVarFp.placeLimitOrder(limitOrderRequest, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Place a market order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
         * @summary Place market order
         * @param {MarketOrderRequest} marketOrderRequest 
         * @param {PlaceMarketOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeMarketOrder(marketOrderRequest: MarketOrderRequest, accountId?: PlaceMarketOrderAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<EquityOrderResult> {
            return localVarFp.placeMarketOrder(marketOrderRequest, accountId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Trading212PublicAPIApi - object-oriented interface
 * @export
 * @class Trading212PublicAPIApi
 * @extends {BaseAPI}
 */
export class Trading212PublicAPIApi extends BaseAPI {
    /**
     * Cancel a pending or queued equity order by its ID.
     * @summary Cancel order
     * @param {number} id 
     * @param {CancelOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public cancelOrder(id: number, accountId?: CancelOrderAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).cancelOrder(id, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve account summary including total value, cash breakdown, and investment P&L from the Trading212 public API
     * @summary Get account summary
     * @param {GetAccountSummaryAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public getAccountSummary(accountId?: GetAccountSummaryAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).getAccountSummary(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search the Trading 212 instrument universe by symbol or name and return the full Trading 212 tickers. Powers the search-as-you-type box on the ISA page. Matches case-insensitively on short name, ticker prefix, or name substring, ranked best-match first. Never fails the request: an upstream fetch error yields an empty list.
     * @summary Search instruments
     * @param {string} query Free-text query: symbol or name fragment. Blank yields an empty result list.
     * @param {number} [limit] Maximum number of results to return. Clamped to [1, 50]. Defaults to 20.
     * @param {GetInstrumentSearchAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public getInstrumentSearch(query: string, limit?: number, accountId?: GetInstrumentSearchAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).getInstrumentSearch(query, limit, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single equity order by its ID from the Trading212 public API
     * @summary Get order by ID
     * @param {number} id 
     * @param {GetOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public getOrder(id: number, accountId?: GetOrderAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).getOrder(id, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all equity orders from the Trading212 public API
     * @summary Get all orders
     * @param {GetOrdersAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public getOrders(accountId?: GetOrdersAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).getOrders(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single open equity position for the given ticker from the Trading212 public API
     * @summary Get position by ticker
     * @param {string} ticker 
     * @param {GetPositionAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public getPosition(ticker: string, accountId?: GetPositionAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).getPosition(ticker, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all open equity positions from the Trading212 public API
     * @summary Get all open positions
     * @param {GetPositionsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public getPositions(accountId?: GetPositionsAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).getPositions(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place a limit order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
     * @summary Place limit order
     * @param {LimitOrderRequest} limitOrderRequest 
     * @param {PlaceLimitOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public placeLimitOrder(limitOrderRequest: LimitOrderRequest, accountId?: PlaceLimitOrderAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).placeLimitOrder(limitOrderRequest, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place a market order on the selected Trading 212 account. Quantity is positive for buy, negative for sell.
     * @summary Place market order
     * @param {MarketOrderRequest} marketOrderRequest 
     * @param {PlaceMarketOrderAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212PublicAPIApi
     */
    public placeMarketOrder(marketOrderRequest: MarketOrderRequest, accountId?: PlaceMarketOrderAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212PublicAPIApiFp(this.configuration).placeMarketOrder(marketOrderRequest, accountId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CancelOrderAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type CancelOrderAccountIdEnum = typeof CancelOrderAccountIdEnum[keyof typeof CancelOrderAccountIdEnum];
/**
 * @export
 */
export const GetAccountSummaryAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetAccountSummaryAccountIdEnum = typeof GetAccountSummaryAccountIdEnum[keyof typeof GetAccountSummaryAccountIdEnum];
/**
 * @export
 */
export const GetInstrumentSearchAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetInstrumentSearchAccountIdEnum = typeof GetInstrumentSearchAccountIdEnum[keyof typeof GetInstrumentSearchAccountIdEnum];
/**
 * @export
 */
export const GetOrderAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetOrderAccountIdEnum = typeof GetOrderAccountIdEnum[keyof typeof GetOrderAccountIdEnum];
/**
 * @export
 */
export const GetOrdersAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetOrdersAccountIdEnum = typeof GetOrdersAccountIdEnum[keyof typeof GetOrdersAccountIdEnum];
/**
 * @export
 */
export const GetPositionAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetPositionAccountIdEnum = typeof GetPositionAccountIdEnum[keyof typeof GetPositionAccountIdEnum];
/**
 * @export
 */
export const GetPositionsAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetPositionsAccountIdEnum = typeof GetPositionsAccountIdEnum[keyof typeof GetPositionsAccountIdEnum];
/**
 * @export
 */
export const PlaceLimitOrderAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type PlaceLimitOrderAccountIdEnum = typeof PlaceLimitOrderAccountIdEnum[keyof typeof PlaceLimitOrderAccountIdEnum];
/**
 * @export
 */
export const PlaceMarketOrderAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type PlaceMarketOrderAccountIdEnum = typeof PlaceMarketOrderAccountIdEnum[keyof typeof PlaceMarketOrderAccountIdEnum];
